import LazyPromotions from '@/js/multi-section/components/molecules/LazyPromotions/LazyPromotions';

export default LazyPromotions;
